export const RIGHT_LABELS = Object.freeze({
  VehiculeMaxActive: "Véhicules actifs maximum",
  VehiculeMaxSold: "Véhicules vendus maximum",
  ProMemberMax: "Comptes pro supplémentaires maximum",
  TrialDurationDays: "Durée de l'essai",
  PriceMonthlyCents: "Tarif mensuel",
  AnnualDiscountPercent: "Réduction sur l'abonnement annuel",
  ActivityJournalScope: "Journal d’activité",
  VehicleComparison: "Comparaison de véhicules",
  StatisticsBasic: "Statistiques basiques",
  StatisticsAdvanced: "Statistiques avancées",
  AttachmentMaxPerItem: "Pièces jointes par entretien ou relevé",
  AttachmentMaxFileMb: "Taille maximale par fichier (Mo)",
  VehiculeCreate: "Créer un véhicule",
  VehiculeUpdate: "Modifier un véhicule",
  VehiculeDelete: "Supprimer un véhicule",
  ReleverCreate: "Créer un relevé",
  ReleverUpdate: "Modifier tous les relevés",
  ReleverUpdateOwn: "Modifier ses propres relevés",
  ReleverDelete: "Supprimer un relevé",
  EntretienCreate: "Créer un entretien",
  EntretienUpdate: "Modifier tous les entretiens",
  EntretienUpdateOwn: "Modifier ses propres entretiens",
  EntretienDelete: "Supprimer un entretien",
  DataDownload: "Télécharger les données",
  MemberManage: "Gérer les membres professionnels",
  DeletionRequest: "Signaler une donnée à supprimer au responsable du compte",
  PaymentMethodManage: "Gérer les moyens de paiement",
  MaintenanceAutoPlanning: "Planification automatique des entretiens",
  MaintenanceRuleCustomize: "Personnaliser les règles d’entretien par véhicule",
});

export const getRightLabel = (rightName) => RIGHT_LABELS[rightName] || rightName;
